/** @jsxImportSource @emotion/react */
"use client";
import type { MouseEventHandler } from "react";
import { useMemo } from "react";

import {
  collapseHeaderStyles,
  coreMediaStyles,
  useMediaClass,
} from "../../../../utils/media.emotion";
import { CollapseButton } from "../../controls/CollapseButton/CollapseButton.emotion";

export type MediaHeaderProps = {
  onCollapse: MouseEventHandler<HTMLButtonElement>;
  onMouseMove: MouseEventHandler;
  showControls?: boolean;
};

export const MediaHeader = ({
  onCollapse,
  onMouseMove,
  showControls = true,
}: MediaHeaderProps) => {
  const mediaClass = useMediaClass();

  const headerStyle = useMemo(
    () => collapseHeaderStyles[mediaClass],
    [mediaClass],
  );

  return (
    <div
      key={"mediaHeader"}
      css={[
        headerStyle,
        coreMediaStyles.edgeBase,
        mediaClass.includes("video") && coreMediaStyles.topEdgeAbsolute,
        mediaClass.includes("video") &&
          showControls &&
          coreMediaStyles.edgeVisibleAbsolute,
      ]}
      onMouseMove={onMouseMove}
    >
      <CollapseButton onClick={onCollapse} />
    </div>
  );
};
